export default function parseSessionTime(therapyTime) {
    let therapyHours = Math.floor(therapyTime / (3600 * 2));
    let therapySecondsRemaining = therapyTime/2 - therapyHours * 3600;
    let therapyMinutes = Math.floor(therapySecondsRemaining / 60);
    let therapyString = therapyHours.toString() + "h, " + therapyMinutes.toString() + "m";
    return therapyString;
}